import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-application',
  templateUrl: './leave-application.component.html',
  styleUrls: ['./leave-application.component.css']
})
export class LeaveApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
